import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowLeft, ShieldCheck } from "lucide-react";
import mx from "../i18n/mx.json";

// Spanish only, per requirement
export default function ThankYou() {
  const t = mx.thankyou;
  return (
    <main className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-16" data-testid="thank-you-page">
      <div className="max-w-xl w-full bg-white border border-slate-200 rounded-xl p-8 md:p-12 text-center shadow-xl">
        <div className="mx-auto w-16 h-16 rounded-full bg-emerald-50 grid place-items-center border-2 border-[#006837]">
          <CheckCircle2 className="w-9 h-9 text-[#006837]" aria-hidden="true" />
        </div>
        <h1 className="mt-6 font-heading text-2xl sm:text-3xl font-extrabold text-slate-900" data-testid="thank-you-title">
          {t.title}
        </h1>
        <p className="mt-3 font-semibold text-slate-800">{t.subtitle}</p>
        <p className="mt-4 text-slate-600 leading-relaxed">{t.body}</p>
        <div className="mt-6 p-4 bg-slate-50 border border-slate-200 rounded-md flex items-start gap-2 text-left">
          <ShieldCheck className="w-5 h-5 text-[#006837] mt-0.5 shrink-0" aria-hidden="true" />
          <p className="text-xs text-slate-600">{t.note}</p>
        </div>
        <Link
          to="/"
          data-testid="thank-you-back-home"
          className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-md bg-[#0B2545] text-white font-bold hover:bg-[#061528]"
        >
          <ArrowLeft className="w-4 h-4" aria-hidden="true" />
          {t.back}
        </Link>
      </div>
    </main>
  );
}
